import React from 'react'
import { isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle, withProps } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

// import from './../selectors/user.js'
import { fetchingState } from './../helpers/hocs.js'
import { getOptions, pay } from '../store/reducers/giftcards'

import Form from './../components/Form'
import Select from './../components/Select'
import Loader from './Loader'
import InnerHTML from 'script-inner-html'

import validator from 'email-validator'
import { checkLogin, /*checkEmail*/ } from './../containers/Signin'
//import { props } from 'ramda'


const GiftCardsForm = ({ success = null, topics, data = {}, tmpData, setData, peoceed, fetching, submit, intl, bidOverlay, options, checkout, error }) => {
  let denominationOptions = {};
  if (options && options.notFixed) {
    denominationOptions[0] = 'Без фиксированного номинала'    
  }
  if (options && options.optionsArray && options.optionsArray.length > 0) {
    denominationOptions[1] = 'Фиксированный номинал'
  }

  return (
    <div className='Contacts-form__body'>
      {
        success ? (
          checkout ?
            <div className='Container Container_top-negative'>
              <div className='Main Main_privacy'>
                <InnerHTML html={checkout.exec} />
              </div>
              <div className='Home__more'>
                <a href={checkout.url} className='Button Button_black'>
                  <FormattedMessage id='profile_sidebar.pay' />
                </a>
              </div>
            </div>
            :
            <div className='Contacts-form__title Head'>
              {error}
            </div>


        )
          : (
            <div>
              <h1 className='Contacts-form__title Head'>
                Купить подарочную карту
            </h1>
              {!fetching.info && (
                <div>
                  {(data.isFixed === undefined) && <Select placeholder="Номинал карты" value={tmpData.isFixed}
                    items={denominationOptions} onSubmit={peoceed.bind(this, 'isFixed')}/>}

                  {(data.isFixed === 0 && data.isFixed !== undefined && !data.denomination) && <Form value={tmpData.denomination} type="Number"
                    onInput={setData('denomination')} placeholder="Сумма" onSubmit={peoceed.bind(this, 'denomination')} 
                    btnTitle='giftcardsbuy.send' />}

                  {(data.isFixed === 1 && data.isFixed !== undefined && !data.denomination && options && options.optionsArray)
                    && <Select placeholder="Сумма" value={tmpData.denomination}
                      items={options.optionsArray} onSubmit={peoceed.bind(this, 'denomination')} />}


                  {(data.denomination && !tmpData.emailSetted) && <Form value={tmpData.email} onInput={setData('email')} placeholder="E-mail получателя" 
                  onSubmit={peoceed.bind(this, 'email')} btnTitle='giftcardsbuy.send' />}

                  {(tmpData.emailSetted && !tmpData.phoneSetted) && <Form value={tmpData.phone} onInput={setData('phone')} type="Number"
                    placeholder="Телефон получателя" onSubmit={peoceed.bind(this, 'phone')} btnTitle='giftcardsbuy.send' />}



                  {(tmpData.phoneSetted && !data.giver) && <Form value={tmpData.giver} onInput={setData('giver')} placeholder="От кого" 
                  onSubmit={peoceed.bind(this, 'giver')} btnTitle='giftcardsbuy.send' />}

                  {(data.giver && !data.text) && <Form value={tmpData.text} onInput={setData('text')} placeholder="Текст / пожелание для получателя карты" onSubmit={peoceed.bind(this, 'text')} />}
                  {(data.text && !data.giverPhone) && <Form value={tmpData.giverPhone} onInput={setData('giverPhone')} type="Number"
                    placeholder="Ваш телефон" onSubmit={peoceed.bind(this, 'giverPhone')} btnTitle='giftcardsbuy.send' />}

                  {(data.giverPhone && !data.type) && <Select placeholder="Вид карты" value={tmpData.type}
                    items={{ 'ecard': 'Электронная карта', 'mcard': 'Физическая карта' }} onSubmit={peoceed.bind(this, 'type')} />}

                  {(data.type === 'mcard' && !data.delivery) && <Select placeholder="Доставка" value={tmpData.delivery}
                    items={{ 'pickup': 'Самовывоз (офис партнера)', 'courier': 'Доставка курьером' }} onSubmit={peoceed.bind(this, 'delivery')} />}

                  {(data.type === 'ecard' || data.delivery) && <button className='Button Button_white' onClick={submit}>
                    Купить сертификат
                </button>/*onClick={submit} */}
                </div>
              )}

              {(fetching.send || fetching.info) && <Loader isLight />}
              {!isNil(success) && <div className='Text'>
                Ooof, some error
            </div>}
            </div>
          )

      }
    </div>
  )
}

const mapStateToProps = state => ({ ...state.feedback, ...state.giftcards, ...state.pay })

const mapDispatchToProps = dispatch => bindActionCreators({ getOptions, pay }, dispatch)

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('data', 'setData', {}),
  withState('tmpData', 'setTmpData', {}),
  withState('success', 'setSuccess', null),
  withState('error', 'setError', ''),
  fetchingState({ multi: true }),
  withHandlers({

    setData: ({ setTmpData, tmpData }) => field => e => {
      tmpData[field] = e
      setTmpData(tmpData)
    },
    clearData: ({ setData }) => () => {
      setData({})
    },
    peoceed: ({ setData, data, setTmpData, tmpData, options }) => (field, e) => {
      e && e.preventDefault && e.preventDefault()

      if (field === 'email' && tmpData[field]) {
        if (validator.validate(tmpData[field])) {
          data[field] = tmpData[field]
          setTmpData({ ...tmpData, 'emailSetted': true })
        }
      } else if (field === 'denomination') {
        if (data.isFixed === 1 && options) {
          data[field] = options.optionsArray[e]
        } else if (data.isFixed === 0 && tmpData[field] > 0) {//введенное значение номинала должно быть больше нуля

          data[field] = tmpData[field]
        }
      } else if (field === 'phone' || field === 'giverPhone') {//проверка номера телефона на валидность
        if (tmpData[field] && checkLogin(tmpData[field]))
          data[field] = tmpData[field]
      } else {//if (!checkLogin(data.login)) return
        data[field] = (field === 'isFixed' || field === 'delivery' || field === 'type') ? e : tmpData[field]
      }
      setData(data)
      if (field === 'isFixed' || field === 'delivery' || field === 'type') setTmpData({ ...tmpData, [field]: e })
      if (field === 'email' && !tmpData.email) setTmpData({ ...tmpData, 'emailSetted': true })//email можно не указывать
      if (field === 'phone' && tmpData.email || data.phone) setTmpData({ ...tmpData, 'phoneSetted': true })//если указан email, ожно не указывать телефон
    },
    submit: ({ tmpData, data, setSuccess, fetchingWrap, pay, noLoader = true, getOptions, options, setError }) => async e => {
      e && e.preventDefault()
      setSuccess(null)
      tmpData.isFixed = (tmpData.isFixed === "0") ? false : true;

      data = { ...tmpData, denomination: data.denomination, delivery: data.delivery, type: data.type }

      const result = noLoader ? await pay(data) : await fetchingWrap(pay.bind(this, data))

      if (result === 200) {
        setSuccess(true)
        setError('')
      } else if (result === 409) {
        setSuccess(true)
        setError('Доступных карт данного типа нет в наличии')
      } else {
        setSuccess(true)
        setError('Ошибка')
      }

    }
  }),
  withProps(props => {
    return ({
      data: { ...props.info, ...props.data, ...props.options },
      tmpData: { ...props.info, ...props.tmpData }
    })
  }),
  lifecycle({
    componentWillMount() {
      this.props.clearData()
      this.props.setTmpData({})
      this.props.getOptions()
    },
    componentWillUnmount() {
      this.props.setTmpData({})
      this.props.setSuccess(null)
      this.props.clearData()
    }
  })
)(GiftCardsForm))



// WEBPACK FOOTER //
// ./src/components/GiftCardsForm.jsx